import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { lighten } from '@mui/system';

type CloseBlockedIndicatorProps = {
  visible: boolean;
};

const CloseBlockedIndicator = styled('span')<CloseBlockedIndicatorProps>(
  ({ theme, visible }) => ({
    position: 'absolute',
    bottom: 6,
    right: 12,
    backgroundColor: lighten(theme.palette.warning.light, 0.1),
    width: 24,
    height: 3,
    color: 'white',
    borderRadius: 2,
    opacity: visible ? 1 : 0,
    transition: theme.transitions.create(['opacity']),
  }),
  addHighContrastStyles({
    backgroundColor: 'white',
  }),
);

export default CloseBlockedIndicator;
